import { useRef, useState} from 'react';
import {
	ControlProps,
	components
} from 'react-select';
import { IAGSelect } from "./AGSelect.props";
import { AGOptionTag, AGSelect as Select } from "./AGSelect.styled";

const customSelectStyles = {
	dropdownIndicator: () => ({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "40px",
		height: "100%",
	}),
};


const AGSelect: React.FC<IAGSelect> = ({ icon, isMultiDisabled, isAllowMobile = true, isShowFull = false, isIconStart = false, ...props }: IAGSelect) => {
	const DropdownIndicator = () => {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" width="30" height="8" viewBox="0 0 13 8" fill="none">
				<path d="M0.914688 1.40367L0.914672 1.40369L0.917491 1.40644L6.26749 6.63144L6.5015 6.85998L6.73442 6.63033L12.0844 1.35533L12.0844 1.35533L12.0861 1.35367C12.1809 1.25885 12.3199 1.25885 12.4147 1.35367C12.5092 1.44822 12.5095 1.58662 12.4155 1.68143C12.4152 1.68171 12.415 1.68199 12.4147 1.68227L6.66676 7.33021L6.66676 7.3302L6.66469 7.33227C6.56838 7.42857 6.52352 7.43463 6.50039 7.43463C6.44147 7.43463 6.39042 7.4202 6.32064 7.36707L0.585263 1.73143C0.491268 1.63663 0.491545 1.49822 0.586093 1.40367C0.680918 1.30885 0.819863 1.30885 0.914688 1.40367Z" fill={props.arrowColor ? props.arrowColor : "#637381"} stroke={props.arrowColor ? props.arrowColor : "#637381"} strokeWidth="0.666667" />
			</svg>
		);
	};

	const ClearIndicator = (props: any) => {
		const { clearValue, getValue } = props;
		const selectedOptions = getValue();

		if (selectedOptions.length <= 1) {
			return null;
		}

		return (
			<components.ClearIndicator {...props} />
		);
	};

	const Control = ({ children, ...props }: ControlProps<any, false>) => {
		return <components.Control {...props}>
			{icon &&
				<div className="ml-[15px]">
					{icon}
				</div>
			}
			{children}
		</components.Control>;
	};
	const selectRef = useRef<any>(null);
	const hasMinHeight = props.options && props.options.length > 5;
	const [inputValue, setInputValue] = useState("");
	const selectedValues = props.value;
	const hasSelectedValues = Array.isArray(selectedValues)
	? selectedValues.length > 0
	: !!selectedValues;
	const userHasTyped = inputValue.trim().length > 0 || hasSelectedValues;

	if (icon)
		return (
			<Select
				inputValue={inputValue}
				onInputChange={(value) => setInputValue(value)}
				className="custom-select"
				menuShouldScrollIntoView
				styles={{
					multiValueRemove: (baseStyles) => ({
						...baseStyles,
						color: "#ffffff",
						background: "#637381",
						borderRadius: "7px",
						"&:hover": { color: "#ffffff", background: "#637381" },
						fontSize: "0.875rem",
					}),
					placeholder: (baseStyles) => ({
						...baseStyles,
						color: "#bcbcbc",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						fontSize: "0.875rem",
					}),
					multiValueLabel: (baseStyles) => ({
						...baseStyles,
						color: "#ffffff",
						maxWidth: 280,
					}),
					multiValue: (baseStyles) => ({
						...baseStyles,
						color: "#ffffff",
						background: "#637381",
						borderRadius: "7px",
						paddingRight: "3px",
						justifyContent: "space-between",
						".css-wsp0cs-MultiValueGeneric": {
							backgroundColor: "#637381",
							color: "#ffffff",
							borderRadius: "7px",
						},
						fontSize: "0.875rem",
						...(isShowFull === true ? {
							flex: "1 1 auto",
							minWidth: "100%",
							maxWidth: "100%",
						} : {
							maxWidth: "45%",
						}),
						"@media (max-width: 768px)": {
							...(isShowFull === true ? {
								maxWidth: "unset",
								flex: "unset",
								minWidth: "unset"
							} : {
								maxWidth: "unset",
							})
						},
					}),
					singleValue: (baseStyles) => ({
						...baseStyles,
						color: props.isSelectedOption ? "#ffffff" : "#637381",
						fontSize: "0.875rem",
						...(isAllowMobile === false && {
							"& span": {
								position: "absolute",
								top: "0px",
								left: "10px",
								zIndex: "9999",
								textOverflow: "ellipsis",
								width: "calc(100% - 20px)",
								overflow: ""
							}
						})
					}),
					control: (baseStyles, state) => ({
						...baseStyles,
						boxShadow: "none",
						borderRadius: 7,
						borderColor: state.isFocused ? "#bcbcbc" : "#DFE4EA",
						"&:hover": { borderColor: "#bcbcbc" },
						fontSize: "0.875rem",
						color: "#637381 !impotent",
						backgroundColor: state.isDisabled ? "#f3f3f3" : props.isSelectedOption ? "rgb(44 118 170)" : "#ffffff",
					}),
					menu: (provided) => ({
						...provided,
						borderRadius: "7px",
						overflow: "hidden",
						...(isAllowMobile === false && {
							zIndex: "99999"
						}),
					}),
					...customSelectStyles,
					option: (provided, state) => ({
						...provided,
						marginTop: 0,
						backgroundColor: state.isDisabled
							? "#f3f3f3"
							: state.isFocused ?
								"#f2f2f2"
								: "white",
						color: "#637381",
						opacity: state.isDisabled ? "0.5" : "",
						minHeight: 36,
						fontSize: "0.875rem",
						wordBreak: 'break-word',
						cursor: !state.isDisabled ? "pointer" : "default",
						":hover": {
							backgroundColor: "#f2f2f2",
							color: "#637381",
						},
					}),
					indicatorsContainer: (provided, state) => ({
						...provided,
						"@media (max-width: 800px)": {
							padding: 1,
							display: "flex",
							alignItems: "center"
						},
					}),
					menuList: (baseStyles) => ({
						...baseStyles,
						minHeight: hasMinHeight ? 216 : "auto"
					}),
				}}
				components={{ DropdownIndicator, IndicatorSeparator: () => null, Control, ClearIndicator }}
				filterOption={(option, inputValue) => {
					return option.label
						?.toLowerCase()
						.includes(inputValue?.toLowerCase());
				}}
				formatOptionLabel={(e: any) => {
					return <span>{e.label} {e.tag ? <AGOptionTag>{e.tag}</AGOptionTag> : null} </span>
				}}
				ref={selectRef}
				{...props}
			/>
		);
	else
		return (
			<Select
				inputValue={inputValue}
				onInputChange={(value) => setInputValue(value)}
				className="custom-select"
				menuShouldScrollIntoView
				styles={{
					multiValueRemove: (baseStyles) => ({
						...baseStyles,
						color: "#ffffff",
						background: "#637381",
						borderRadius: "7px",
						"&:hover": { color: "#ffffff", background: "#637381" },
						fontSize: "0.875rem",
						display: isMultiDisabled ? "none !important" : "inline-flex"
					}),
					placeholder: (baseStyles) => ({
						...baseStyles,
						color: "#bcbcbc",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						fontSize: "0.875rem",
					}),
					multiValueLabel: (baseStyles) => ({
						...baseStyles,
						color: "#ffffff",
						maxWidth: 280
					}),
					multiValue: (baseStyles) => ({
						...baseStyles,
						color: "#ffffff",
						background: "#637381",
						borderRadius: "7px",
						paddingRight: "3px",
						justifyContent: "space-between",
						".css-wsp0cs-MultiValueGeneric": {
							backgroundColor: "#637381",
							color: "#ffffff",
							borderRadius: "7px",
						},
						fontSize: "0.875rem",
						...(isShowFull === true ? {
							flex: "1 1 auto",
							minWidth: "100%",
							maxWidth: "100%",
						} : {
							maxWidth: "45%",
						}),
						"@media (max-width: 768px)": {
							...(isShowFull === true ? {
								maxWidth: "unset",
								flex: "unset",
								minWidth: "unset"
							} : {
								maxWidth: "unset",
							})
						},
					}),
					singleValue: (baseStyles) => ({
						...baseStyles,
						color: props.isSelectedOption ? "#ffffff" : "#637381",
						fontSize: "0.875rem",
						...(isAllowMobile === false && {
							"& span": {
								position: "absolute",
								top: "0px",
								left: "10px",
								zIndex: "9999",
								textOverflow: "ellipsis",
								width: "calc(100% - 20px)",
								overflow: ""
							}
						})
					}),
					control: (baseStyles, state) => ({
						...baseStyles,
						boxShadow: "none",
						borderRadius: 7,
						borderColor: state.isFocused ? "#bcbcbc" : "#DFE4EA",
						"&:hover": { borderColor: "#bcbcbc" },
						fontSize: "0.875rem",
						color: "#637381 !impotent",
						backgroundColor: state.isDisabled ? "#f3f3f3" : props.isSelectedOption ? "rgb(44 118 170)" : "#ffffff",
						paddingLeft: isIconStart ? "25px" : "0px"
					}),
					menu: (provided) => ({
						...provided,
						borderRadius: "7px",
						overflow: "hidden",
						...(isAllowMobile === false && {
							zIndex: "99999"
						}),
					}),
					...customSelectStyles,
					option: (provided, state) => ({
						...provided,
						marginTop: 0,
						backgroundColor: state.isDisabled
							? "#f3f3f3"
							: state.isFocused ?
								"#f2f2f2"
								: "white",
						color: "#637381",
						opacity: state.isDisabled ? "0.5" : "",
						minHeight: 36,
						fontSize: "0.875rem",
						wordBreak: 'break-word',
						cursor: !state.isDisabled ? "pointer" : "default",
						":hover": {
							backgroundColor: "#f2f2f2",
							color: "#637381",
						},
					}),
					indicatorsContainer: (provided, state) => ({
						...provided,
						"@media (max-width: 800px)": {
							padding: 1,
							display: "flex",
							alignItems: "center"
						},
					}),
					menuList: (baseStyles) => ({
						...baseStyles,
						minHeight: userHasTyped ? "auto" : (hasMinHeight ? 228  : "auto")
					}),
				}}
				components={{ DropdownIndicator, IndicatorSeparator: () => null }}
				filterOption={(option, inputValue) => {
					return option.label
						?.toLowerCase()
						.includes(inputValue?.toLowerCase());
				}}
				formatOptionLabel={(e: any) => {
					return <span>{e.label} {e.tag ? <AGOptionTag>{e.tag}</AGOptionTag> : null} </span>
				}}
				ref={selectRef}
				{...props}
			/>
		);
};

export default AGSelect;
